import { render, staticRenderFns } from "./NevronCopyMovePopupModal.vue?vue&type=template&id=66ff8436&v-on-clickaway=cancel&"
import script from "./NevronCopyMovePopupModal.vue?vue&type=script&lang=ts&"
export * from "./NevronCopyMovePopupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports